import { render } from "./ModuleStyleguideBrand.vue?vue&type=template&id=c7a1428e"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__